module.exports = __webpack_public_path__ + "img/img3.2f26167a.jpg";